import type {CompanyProfile} from "../ProfileStore.tsx";

export type DatabagConfiguration = {
    databag_id: number
    columns: ColumnConfiguration[]
}

export type ColumnConfiguration = {
    table_name: string
    column_name: string
    stat_count: number
    stat_unique: number
    stat_empty: number
    stat_null: number
    stat_is_number: number
    stat_min: string
    stat_max: string

    display_name: string
    description: string
    in_use: boolean
    default_visibility: boolean
    mh_in_use: boolean
    mh_default_visibility: boolean
    default_order: number | null
    width: number | null
    min_width: number | null
    max_width: number | null
}

type Value = number | string | boolean | object;

export type CustomerConfigurationKeys =
    'LOCALE'
    | 'CURRENCY'
    | 'DATA_YEAR_START'
    | 'DISABLE_PPV'
    | 'DISABLE_GINI'
    | 'TEST_REVIEW_PAGE'
    | 'CATEGORIZATION_SCORE'
    | 'CATEGORIZATION_FILE_DL'
    | 'ADV_DASH_GRAPHS'
    | 'MH_UNLIMITED_ACCESS'

export type CustomerConfiguration = {
    key: CustomerConfigurationKeys
    value: Value | Value[] | {[key: string]: Value | Value[]}
}
export type CustomerConfigurationMap = Map<CustomerConfigurationKeys, CustomerConfiguration>;

export type ProfileKeyMapType = {
    [key in CustomerConfigurationKeys]?: {
        pKey: keyof CompanyProfile | null,
        default: any,
        operation?: (value: any) => any,
    }
}

/**
 * TODO [CAT-3252]: Once FE is migrates we can phase this out
 */
export const ProfileKeyMap: ProfileKeyMapType = {
    'CATEGORIZATION_SCORE': {pKey: 'categorizationShowScore', default: true},
    'CATEGORIZATION_FILE_DL': {pKey: 'categorizationShowFileDownload', default: false},
    'MH_UNLIMITED_ACCESS': {pKey: null, default: false},
}

/**
 * TODO [CAT-3330]: Once usage of default_order in column configuration is adopted we can phase this out
 *      These values start at negative to take precedence over default ordering of config, because we think users
 *      usually start from 1
 */
export const CategorizationDefaultOrdering: {[key: string]: number} = {
    'supplier_id': -20,
    's_name': -20,
    'p_id': -19,
    'p_spend': -18,
    'previous_cat_id': -17,
    'suggestion_score': -16,
    'cat_id': -15,
    'reasoning': -14,
    'state': -13,
}